import { apiClient } from "./api";
import { getConsent } from "./consent";

function getSessionId() {
  let sid = sessionStorage.getItem("pv_visitor_session");
  if (!sid) {
    sid = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem("pv_visitor_session", sid);
  }
  return sid;
}

export function trackPageview(path) {
  if (getConsent() === "declined") return;
  apiClient
    .post("/track/pageview", { session_id: getSessionId(), path, referrer: document.referrer || null })
    .catch(() => {});
}
